import { TBookingContext } from '@providers/booking/types'
import startOfDay from 'date-fns/startOfDay'
import sub from 'date-fns/sub'

export const findIndexDate = (dates: Date[], date: Date) => {
  const dateTime = date.getTime()
  return dates.findIndex((item) => item.getTime() === dateTime)
}

export const isDataInCache = (startDate: Date, endDate: Date, state: TBookingContext) => {
  const fromDate = startOfDay(startDate)
  const toDate = startOfDay(sub(endDate, { days: 1 }))

  const rc =
    state.data.offerAvailability?.reduce((acc, item) => {
      if (item.id === fromDate.getTime() || item.id === toDate.getTime()) {
        acc++
      }
      return acc
    }, 0) || 0

  return rc == 2
}
